import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { t } from '../i18n';
const API = window.location.origin + '/api';
const Dashboard = () => {
  const token = localStorage.getItem('token');
  const dealer = JSON.parse(localStorage.getItem('dealer') || '{}');
  const headers = { Authorization: `Bearer ${token}` };
  const [offers, setOffers] = useState([]);
  const [matches, setMatches] = useState([]);
  const [stats, setStats] = useState<any>(null);
  const [prices, setPrices] = useState<any>(null);
  useEffect(() => {
    axios.get(`${API}/offers`, { headers }).then(res => setOffers(res.data.offers || []));
    axios.get(`${API}/matches`, { headers }).then(res => setMatches(res.data.matches || []));
    axios.get(`${API}/matches/stats`, { headers }).then(res => setStats(res.data.stats));
    axios.get(`${API}/prices`, { headers }).then(res => setPrices(res.data.prices));
  }, []);
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-1">Dashboard</h1>
      <p className="text-gray-400 text-sm mb-6">Welcome back, {dealer.company_name}</p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
        <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm"><p className="text-gray-500 text-xs">{t('openOffers','Open Offers')}</p><p className="text-2xl font-bold text-gray-900 mt-1">{offers.length}</p></div>
        <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm"><p className="text-gray-500 text-xs">{t('totalMatches','Total Matches')}</p><p className="text-2xl font-bold text-gray-900 mt-1">{matches.length}</p></div>
        <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm"><p className="text-gray-500 text-xs">{t('feePerMatchLabel','Fee per Match')}</p><p className="text-2xl font-bold mt-1" style={{color:'#B8860B'}}>0.1%</p></div>
        <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm"><p className="text-gray-500 text-xs">{t('completedSwaps','Completed Swaps')}</p><p className="text-2xl font-bold text-green-600 mt-1">{stats?.completed_swaps||0}</p></div>
      </div>
      <div className="grid grid-cols-2 gap-3 mb-6">
        <Link to="/new-offer" className="bg-white border border-gray-200 rounded-xl p-5 hover:border-gray-400 transition-colors shadow-sm"><p className="text-2xl mb-2">+</p><p className="text-gray-900 font-semibold text-sm">{t('newOfferBtn','New Offer')}</p><p className="text-gray-500 text-xs mt-1">Post a new swap offer</p></Link>
        <Link to="/matches" className="bg-white border border-gray-200 rounded-xl p-5 hover:border-gray-400 transition-colors shadow-sm"><p className="text-2xl mb-2">⇄</p><p className="text-gray-900 font-semibold text-sm">{t('viewMatches','View Matches')}</p><p className="text-gray-500 text-xs mt-1">Manage your active matches</p></Link>
      </div>
      {prices && (
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm">
          <p className="text-gray-900 font-semibold text-sm mb-4">{t('marketSnapshot','Market Snapshot')} — EUR/oz</p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[{label:'Gold (Au)',value:prices.gold,color:'#B8860B'},{label:'Silver (Ag)',value:prices.silver,color:'#6b7280'},{label:'Platinum (Pt)',value:prices.platinum,color:'#374151'},{label:'Palladium (Pd)',value:prices.palladium,color:'#1a1a2e'}].map(m=>(
              <div key={m.label}><p className="text-xs text-gray-400">{m.label}</p><p className="text-lg font-bold" style={{color:m.color}}>€{m.value?.toLocaleString('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2})}</p></div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
export default Dashboard;
